<template>
  <div id="admin">
    <menu-admin/>
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="title text-center"><i class="fa fa-file-o"></i>  Publicações</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="input-group" style="margin-bottom: 10px">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fa fa-search"></i></span>
            </div>
            <input type="text" class="form-control" id="myInput" @keyup.enter="getPublications(1)" v-model="search" placeholder="Filtrar publicações..." />
            <div class="input-group-append">
              <span class="input-group-text" @click="redirectURL('/admin/publication/0')"><i class="fa fa-plus"></i></span>
            </div>
            <div class="input-group-append">
              <span class="input-group-text" @click="getPublications(1)"><i class="fa fa-refresh"></i></span>
            </div>
          </div>

          <table class="table table-bordered table-bordered" style="background: white">
            <thead>
            <tr>
              <th width="20">ID</th>
              <th scope="col">Publicação</th>
              <th class="text-center" scope="col" width="50">Revisao</th>
              <th class="text-center" scope="col" width="100">Atualização</th>
              <th class="text-center" scope="col" width="100">Compra</th>
              <th class="text-center" scope="col" width="100">Renovação</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="publication in publications" v-bind:key="publication.id">
              <td>{{publication.id}}</td>
              <td>
                <a href="javascript:;" @click="redirectURL('/admin/publication/'+publication.id)">{{ publication.name }}</a><br />
                <small>{{ publication.applicability }}</small>
              </td>
              <td class="text-center"><small>v.{{ publication.version }}</small></td>
              <td class="text-center"><small>{{ publication.date | formatDate }}</small></td>
              <td class="text-center"><small>R$ {{ publication.price | formatPrice }}</small></td>
              <td class="text-center">
                <small v-if="publication.is_signature">
                  R$ {{ publication.price_signature | formatPrice }}
                </small>
                <small v-else>
                  -
                </small>
              </td>
            </tr>
            <tr v-show="!publications.length"><td colspan="5" class="text-center">Nenhum resultado pode ser encontrado</td></tr>
            </tbody>
          </table>
          <div class="pagination pagination-medium pagination-right">
            <div class="pull-left">
              Pagina {{current}} de {{pages}}
            </div>
            <ul>
              <li id="previous"><a href="javascript:;" @click="getPublications(previous)">Anterior</a></li>
              <li id="next"><a href="javascript:;" @click="getPublications(next)">Próxima</a></li>
            </ul>
          </div>
        </div>

      </div>
    </div>

    <footer-admin/>
  </div>
</template>

<script>
  import publication from "../../api/publication"
  import menuAdmin from "../admin/common/menu-admin"
  import footerAdmin from "../admin/common/footer-admin"
  import { mapState } from 'vuex'
  import mixins from "../../helpers/mixins"
  export default {
    name: "AdminPublications",
    mixins: [mixins],
    data () {
      return {
        publications: [],
        page: 1,
      }
    },
    components: { menuAdmin, footerAdmin },
    computed: {
      ...mapState(['logged'])
    },
    methods: {
      getPublications(page){
        this.page = page
        publication.list(this.page, this.search).then((response)  =>  {
          this.publications = response.data.results
          this.treatPagination(page, response.data.count, response.data.pages)
        })
      }
    },
    activated(){
      this.getPublications(this.page)
    },
    mounted(){
      this.getPublications(this.page)
    }
  }
</script>

<style scoped>

</style>
